import { BaseModel } from './base.model'
import * as _ from 'lodash'
import { Hub} from './hub.model'
import { HubCourse } from './hub-course.model'
import { Moment } from "moment"

export class SlotSubscription extends BaseModel<SlotSubscription> {
  static DEFAULT_ATTRIBUTES = { }

  id: number
  licenseNumber: string
  firstName: string
  lastName: string
  middleName: string
  phone: string
  timeFrom: Moment
  createdAt: Moment
  status: string
  hub: Hub
  hubId: number
  hubCourse: HubCourse
  hubTimeIntervalId: number
  hubCourseId: number
  uuid: string
  locale: string
  country: string 

  constructor(attributes = {}) {
    super(attributes)
    if (this.timeFrom && this.hub.utcOffset){
      this.timeFrom.utcOffset(this.hub.utcOffset)
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/slot-subscription.model.ts